/* eslint-disable jsx-a11y/anchor-has-content */
import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import { reaction } from 'mobx';
import { v4 as uuidv4 } from 'uuid';
import cx from 'classnames';
import {
  Popup, Icon, Breadcrumb, List, Menu, Modal, Header
} from 'semantic-ui-react';
import { withTranslation } from 'react-i18next';
import FileSaver from 'file-saver';
import $ from 'jquery';
import {
  //SCANS_LABEL_ARCHIVE,
  REPORT_EXTENSION_CSV,
  REPORT_EXTENSION_EXCEL,
  REPORT_EXTENSION_JSON,
} from '../../constants/reports';
import { convertPropertiesToCamelCase } from '../../utils/shared';
import api from '../../api';
import ExportModal from '../Modal/ExportModal';
import HeaderError from '../SubHeader/HeaderError';
import HeaderLinkDetail from '../SubHeader/HeaderLinkDetail';
import LitigatorDetailModal from '../Modal/LitigatorDetailModal';
import CycloneDXDocumentGenerator from '../SBOM/CycloneDXDocumentGenerator';
import SPDXDocumentGenerator from '../SBOM/SPDXDocumentGenerator';
import NISModal from '../NISTools/NISModal';
import VexGenerator from '../SBOM/VexGenerator';
import CBOMGenerator from '../SBOM/CBOMGenerator';
import WithRouter from '../Extensions/WithRouter';

class LicenseDetailedPanel extends Component {
  constructor(props) {
    super(props);
    this.modalAction = null;
    this.modalBody = null;
    this.modalHeader = null;
    this.modalSubBody = null;
    this.disposers = [];
    this.state = {
      isLoading: false,
      isOpenMLD: false,
      litigatorData: {},
      overviewSummary: {},
      isLoadError: false,
      errorHeader: null,
      errorBody: null,
      modalExportIsOpen: false,
      isDownloadingReport: false,
      isOpenMenu: false,
      isOpenMCX: false,
      isOpenMCD: false,
      isOpenAlertModal: false,
      isOpenMNA: false,
      isOpenMVX: false,
      toExport: '',
      isOpenMCB: false,
    };
  }

  componentDidMount() {
    const { state, params } = this.props;
    this.onUpdateLoading();
    $(document).on(
      'mouseover',
      '.result_header_inner .result_header_box .name .file_name span',
      this.handleMouseOver
    );

    this.disposers.push(
      reaction(
        () => { return state.user.currentPrecisionLevelActive; },
        () => {
          this.getLicenseSummaryDetail(params.idReport, state.user.currentPrecisionLevel);
        }
      )
    );
  }

  componentDidUpdate(prevProps, prevState) {
    const { isLoading } = this.state;
    const { params, state, location } = this.props;

    if (prevProps.params.idReport !== params.idReport) {
      this.getLicenseSummaryDetail(params.idReport);
      return;
    }

    if (prevState.isLoading !== isLoading && isLoading) {
      const navState = state.user.transientNavigationState;
      const detailType = navState ? state.user.currentPrecisionLevel : undefined;

      this.getLicenseSummaryDetail(params.idReport, detailType);

      if (navState) {
        state.user.clearTransientNavigationState();
      }
      return;
    }

    const hasLocationChanged = prevProps.location.pathname !== location.pathname;
    const isSameReport = prevProps.params.idReport === params.idReport;

    if (hasLocationChanged && isSameReport) {
      this.getLicenseSummaryDetail(params.idReport, state.user.currentPrecisionLevel);
    }
  }

  componentWillUnmount() {
    $(document).off(
      'mouseover',
      '.result_header_inner .result_header_box .name .file_name span',
      this.handleMouseOver
    );
    this.disposers.forEach((disposer) => { return disposer(); });
  }

  handleMouseOver = (event) => {
    const $this = $(event.currentTarget);
    if (event.currentTarget.offsetWidth < event.currentTarget.scrollWidth && !$this.attr('title')) {
      $this.attr('title', $this.text());
    }
  };

  handleExport = () => {
    this.setState({
      modalExportIsOpen: true,
      isOpenMenu: false,
    });
  };

  handleSpdx = () => {
    this.setState({
      isOpenMCX: true,
    });
  };

  handleCycloneDx = () => {
    this.setState({
      isOpenMCD: true,
    });
  };

  handleVexBom = () => {
    this.setState({
      isOpenMVX: true,
    });
  };

  handleNIS = () => {
    this.setState({
      isOpenMNA: true,
    });
  };

  handleMenuOpen = () => {
    this.setState({
      isOpenMenu: true,
    });
  };

  handleMenuClose = () => {
    this.setState({
      isOpenMenu: false,
    });
  };

  handleMLDClose = () => {
    this.setState({
      isOpenMLD: false,
    });
  };

  handleCBOM = () => {
    const { t } = this.props;
    const { overviewSummary } = this.state;
    const { hasCrypto } = overviewSummary;

    if (hasCrypto) {
      this.setState({
        isOpenMCB: true,
      });
    } else {
      this.modalAction = t('modal.title.notice');
      this.modalBody = t('modal.message.no_crypto_data');
      this.modalHeader = null;

      this.setState({
        isOpenAlertModal: true,
      });
    }
  };

  handleBookmark = () => {
    const { overviewSummary } = this.state;
    const { location, state } = this.props;
    let currentViewPoint;
    if (location.pathname.indexOf('overview') !== -1) {
      currentViewPoint = 'overview';
    } else if (location.pathname.indexOf('component') !== -1) {
      currentViewPoint = 'component';
    } else if (location.pathname.indexOf('security') !== -1) {
      currentViewPoint = 'security';
    } else if (location.pathname.indexOf('license') !== -1) {
      currentViewPoint = 'license';
    } else if (
      location.pathname.indexOf('policy') !== -1
      && location.pathname.indexOf('project') !== -1
    ) {
      currentViewPoint = 'policy';
    }
    api
      .toggleBookmark(
        {
          uploaded_file_id: overviewSummary.uploadedFileId,
          view_point: currentViewPoint,
        }
      )
      .then((response) => {
        const res = response.response;
        this.setState((prevState) => {
          return {
            overviewSummary: {
              ...prevState.overviewSummary,
              isBookmark: res.is_bookmark,
            }
          };
        });
        state.report.setActiveBookMark();
      })
      .catch((err) => {
        console.log(err);
      });
  };

  handleLitigatorDetailModal = (e, string) => {
    let value;
    if (string.indexOf('SFC') > -1) {
      value = 'Software Freedom Conservancy';
    } else if (string.indexOf('McHardy') > -1) {
      value = 'Patrick McHardy';
    } else if (string.indexOf('Patent') > -1) {
      value = 'Patents';
    }

    if (!value) {
      value = string;
    }

    const data = {
      litigator_name: value,
    };
    api
      .getComponentLitigatorDetail(data)
      .then((response) => {
        this.setState({
          litigatorData: response.response,
          isOpenMLD: true,
        });
      })
      .catch((err) => {
        console.log(err);
      });
  };

  onUpdateLoading = () => {
    this.setState({
      isLoading: true,
    });
  };

  getLicenseSummaryDetail = async (value, type) => {
    const { state } = this.props;

    try {
      const response = await api.getLicenseSummaryDetail(value, type);
      const data = convertPropertiesToCamelCase(response.response);

      this.setState({
        overviewSummary: data,
      });
      state.company.setLicenseSummaryDetail(data);
    } catch (err) {
      console.log(err);
      const o = err.data.response;
      if (!o) {
        this.setState({
          isLoadError: true,
          errorHeader: 'Access Denied',
          errorBody: 'Unknown error. Please contact Insignary.',
        });
      } else if (o.error === '422-401') {
        this.setState({
          isLoadError: true,
          errorHeader: 'Access Denied',
          errorBody: 'You do not have permission to access this file.',
        });
      }
    } finally {
      this.setState({
        isLoading: false,
      });
    }
  };

  generateToken = (length) => {
    let i = 0;
    let result = '';
    const timeStamp = new Date();
    const components = [
      timeStamp.getYear(),
      timeStamp.getMonth(),
      timeStamp.getDate(),
      timeStamp.getHours(),
      timeStamp.getMinutes(),
      timeStamp.getSeconds(),
      timeStamp.getMilliseconds(),
    ];
    const id = components.join('');
    const charactersLength = id.length;

    for (i; i < length; i++) {
      result += id.charAt(Math.floor(Math.random() * charactersLength));
    }

    return result;
  };

  closeExportModal = () => {
    this.setState({
      modalExportIsOpen: false,
      isOpenMCX: false,
      isOpenMCD: false,
      isDownloadingReport: false,
      isOpenMNA: false,
      isOpenMVX: false,
      toExport: '',
    });
  };

  closeModal = () => {
    this.setState({
      isOpenMCB: false,
      isOpenAlertModal: false,
    });
  };

  downloadReport = (exportFormat, exportType, toExport) => {
    const { t, state } = this.props;
    const { currentPrecisionLevel } = state.user;
    const { overviewSummary } = this.state;
    const token = this.generateToken(10);
    const downloadFormatMapping = {
      [REPORT_EXTENSION_CSV]: 'csv',
      [REPORT_EXTENSION_EXCEL]: 'xlsx',
      [REPORT_EXTENSION_JSON]: 'zip',
    };

    let type;
    let url;

    if (currentPrecisionLevel) {
      type = currentPrecisionLevel;
    } else {
      type = null;
    }

    if (type) {
      url = `/1/reports/${overviewSummary.uploadedFileId}/export?file_format=${exportFormat}&section=${exportType}&token=${token}&precision_level=${type}&export_to=${toExport}`;
    } else {
      url = `/1/reports/${overviewSummary.uploadedFileId}/export?file_format=${exportFormat}&section=${exportType}&token=${token}&export_to=${toExport}`;
    }

    this.setState({
      isDownloadingReport: true
    });

    api
      .getExportedReport(url)
      .then((res) => {
        let data;
        let confidenceLevelName;
        const blob = new Blob([res], { type: 'application/octet-stream' });

        if (overviewSummary.currentPrecisionLevel === 'narrow') {
          confidenceLevelName = 'high';
        } else if (overviewSummary.currentPrecisionLevel === 'broad') {
          confidenceLevelName = 'low';
        } else {
          confidenceLevelName = overviewSummary.currentPrecisionLevel;
        }
        const fileName = `${overviewSummary.uploadName}_${confidenceLevelName}.${downloadFormatMapping[exportFormat]}`;

        this.modalAction = t('modal.title.notice');

        if (toExport === 's3') {
          data = JSON.parse(new TextDecoder().decode(res));
          const { bucket, key } = data.response;
          this.modalBody = t('modal.message.export_send_s3');
          this.modalHeader = (
            <p className="modal_list" style={{ paddingTop: '10px' }}>
              <b>{t('modal.title.bucket')}</b>
              &nbsp;
              {bucket}
            </p>
          );
          this.modalSubBody = (
            <p className="modal_list">
              <b>{t('modal.title.file_storage_path')}</b>
              &nbsp;
              {key}
            </p>
          );
        } else if (toExport === 'email') {
          data = JSON.parse(new TextDecoder().decode(res));
          const { dest_email } = data.response;
          this.modalBody = t('modal.message.export_send_email');
          this.modalHeader = t('modal.message.export_send_to_email', { email: dest_email });
          this.modalSubBody = null;
        } else if (toExport === 'local') {
          FileSaver.saveAs(blob, fileName);
          this.modalBody = t('modal.message.export_send_local');
          this.modalHeader = null;
          this.modalSubBody = null;
        }
        this.setState({
          isDownloadingReport: false,
          modalExportIsOpen: false,
          isOpenAlertModal: true,
          toExport,
        });
      })
      .catch((err) => {
        console.log(err);
        let jsonParse;
        const ArrayBufferView = Object.getPrototypeOf(Object.getPrototypeOf(new Uint8Array())).constructor;
        if (err.data instanceof ArrayBuffer || err.data instanceof ArrayBufferView) {
          jsonParse = JSON.parse(new TextDecoder().decode(err.data));
        } else {
          jsonParse = err.data;
        }
        const o = jsonParse.response;
        this.modalAction = t('modal.title.attention');

        if (!o.error) {
          this.modalBody = t('modal.error.unknow_error');
        }

        if (o.error === '422-002') { // recovery email
          this.modalBody = t('modal.error.error_422_002_export');
        }

        if (o.error === '422-365') { // license expired
          this.modalBody = t('system.message.license_expired');
        }

        if (o.error === '422-366') {
          this.modalBody = o.error_description;
        }

        if (o.error === '422-367') { // smtp error
          this.modalBody = t('modal.error.error_422_368_jira');
        }

        if (o.error === '422-791') {
          this.modalBody = t('modal.error.error_422_791_export');
        }

        this.modalHeader = null;
        this.modalSubBody = null;

        this.setState({
          isDownloadingReport: false,
          modalExportIsOpen: false,
          isOpenAlertModal: true,
        });
      });
  };

  goBack = () => {
    history.back();
  };

  abbreviateNumber = (value) => {
    let newValue = value;
    if (value >= 10000) {
      const suffixes = ['', 'K', 'M', 'B', 'T'];
      const suffixNum = Math.floor(` ${value}`.length / 4);
      let shortValue = '';
      let i = 4; //precision
      for (i; i >= 1; i--) {
        shortValue = parseFloat(
          (suffixNum !== 0 ? value / (1000 ** suffixNum) : value).toPrecision(i) // prettier-ignore
        ); // ** : Math.pow()
        const dotLessShortValue = `${shortValue} `.replace(/[^a-zA-Z 0-9]+/g, '');
        if (dotLessShortValue.length <= 4) {
          break;
        }
      }
      //if (shortValue % 1 !== 0) {
      //const shortNum = shortValue.toFixed(1);
      //console.log(shortNum);
      //}
      newValue = shortValue + suffixes[suffixNum];
    }
    return newValue;
  };

  renderBarChart = (obj) => {
    const { t } = this.props;

    if (typeof obj.undecided === 'undefined') {
      return (
        <div className="bar_chart_wrap">
          <div className="bar_chart">
            <div>
              <div className="bar" style={{ height: '1%' }} />
              <div className="value">{0}</div>
              <div className="bar_chart_tooltip">
                {t('panel.menu.undecided')}
              </div>
            </div>
            <div>
              <div className="bar" style={{ height: '1%' }} />
              <div className="value">{0}</div>
              <div className="bar_chart_tooltip">
                {t('panel.menu.resolved')}
              </div>
            </div>
            <div>
              <div className="bar" style={{ height: '1%' }} />
              <div className="value">{0}</div>
              <div className="bar_chart_tooltip">
                {t('panel.menu.disregarded')}
              </div>
            </div>
          </div>
        </div>
      );
    }
    if (obj.undecided === 0 && obj.resolved === 0 && obj.disregarded === 0) {
      return (
        <div className="bar_chart_wrap">
          <div className="bar_chart">
            <div>
              <div className="bar" style={{ height: '1%' }} />
              <div className="value">{obj.undecided}</div>
              <div className="bar_chart_tooltip">
                {t('panel.menu.undecided')}
              </div>
            </div>
            <div>
              <div className="bar" style={{ height: '1%' }} />
              <div className="value">{obj.resolved}</div>
              <div className="bar_chart_tooltip">
                {t('panel.menu.resolved')}
              </div>
            </div>
            <div>
              <div className="bar" style={{ height: '1%' }} />
              <div className="value">{obj.disregarded}</div>
              <div className="bar_chart_tooltip">
                {t('panel.menu.disregarded')}
              </div>
            </div>
          </div>
        </div>
      );
    }

    const maxKey = Object.keys(obj).reduce((a, b) => {
      return obj[a] > obj[b] ? a : b;
    });

    const undecidedValue = `${Math.round((obj.undecided / obj[maxKey]) * 100)}%`;
    const resolveddValue = `${Math.round((obj.resolved / obj[maxKey]) * 100)}%`;
    const disregardedValue = `${Math.round((obj.disregarded / obj[maxKey]) * 100)}%`;

    return (
      <div className="bar_chart_wrap">
        <div className="bar_chart">
          <div>
            <div className="bar" style={{ height: Math.round((obj.undecided / obj[maxKey]) * 100) < 1 ? (`${1}%`) : (undecidedValue) }} />
            <div className="value">{this.abbreviateNumber(obj.undecided)}</div>
            <div className="bar_chart_tooltip">
              {t('panel.menu.undecided')}
            </div>
          </div>
          <div>
            <div className="bar" style={{ height: Math.round((obj.resolved / obj[maxKey]) * 100) < 1 ? (`${1}%`) : (resolveddValue) }} />
            <div className="value">{this.abbreviateNumber(obj.resolved)}</div>
            <div className="bar_chart_tooltip">
              {t('panel.menu.resolved')}
            </div>
          </div>
          <div>
            <div className="bar" style={{ height: Math.round((obj.disregarded / obj[maxKey]) * 100) < 1 ? (`${1}%`) : (disregardedValue) }} />
            <div className="value">{this.abbreviateNumber(obj.disregarded)}</div>
            <div className="bar_chart_tooltip">
              {t('panel.menu.disregarded')}
            </div>
          </div>
        </div>
      </div>
    );
  };

  renderBookMark = () => {
    const { overviewSummary } = this.state;
    if (overviewSummary.isBookmark) {
      return (
        <a className="icon_box" onClick={this.handleBookmark} onKeyUp={this.handleBookmark}>
          <Icon name="bookmark" />
        </a>
      );
    }
    return (
      <a className="icon_box" onClick={this.handleBookmark} onKeyUp={this.handleBookmark}>
        <Icon name="bookmark outline" />
      </a>
    );
  };

  render() {
    const {
      litigatorData,
      overviewSummary,
      isLoadError,
      errorHeader,
      errorBody,
      isOpenMenu,
      isOpenAlertModal,
      toExport,
      isOpenMNA,
      isOpenMCB,
      isOpenMLD,
      isOpenMCX,
      isOpenMCD,
      isOpenMVX,
      modalExportIsOpen,
      isDownloadingReport,
    } = this.state;
    const { t, state, params } = this.props;

    const tooltipStyle = {
      fontSize: '11px',
      fontWeight: '500',
    };

    const iconStyle = {
      width: '14px',
      height: '14px',
      color: '#969696',
      fontWeight: 'bold',
      fontSize: '12px',
      marginRight: '5px',
    };

    const {
      litigatorCount,
      licenseCount,
      licenseStatus,
      licenseMostFound,
      litigatorMostFound,
      litigatorStatus,
      projectName,
      projectVersionName,
      currentPrecisionLevel,
      uploadName,
    } = overviewSummary;

    return (
      <div>
        <div className="result_header has_expand">
          <div className="result_header_inner">
            <div className="result_header_box">
              {
                !isLoadError ? (
                  <div className="name">
                    <div className="prev_button">
                      <a onClick={this.goBack} onKeyUp={this.goBack} />
                    </div>
                    <Breadcrumb
                      style={{
                        lineHeight: '14px',
                        opacity: '0.5',
                        fontSize: '12px',
                        fontWeight: 'normal',
                        color: '#ffffff',
                        position: 'absolute',
                        top: '-5px',
                      }}
                    >
                      <Breadcrumb.Section>
                        {projectName}
                      </Breadcrumb.Section>
                      <Breadcrumb.Divider style={{ color: '#ffffff' }}>/</Breadcrumb.Divider>
                      <Breadcrumb.Section>
                        {projectVersionName}
                      </Breadcrumb.Section>
                    </Breadcrumb>
                    <div className="file_name">
                      <span>
                        {uploadName}
                      </span>
                      <Popup
                        trigger={(
                          <a className="icon_box">
                            <Icon name="file code outline" />
                          </a>
                        )}
                        on="click"
                        className="sbom_menu"
                        position="bottom left"
                        open={isOpenMenu}
                        onOpen={this.handleMenuOpen}
                        onClose={this.handleMenuClose}
                      >
                        <Menu
                          vertical
                        >
                          {
                            state.user.use_crypto
                            && (
                              <Menu.Item
                                link
                                onClick={this.handleCBOM}
                              >
                                <Icon name="download" style={iconStyle} />
                                CBOM
                              </Menu.Item>
                            )
                          }
                          <Menu.Header className="section_title">SBOM</Menu.Header>
                          <Menu.Item
                            link
                            onClick={this.handleExport}
                          >
                            <Icon name="download" style={iconStyle} />
                            {t('card.menu.clarity')}
                          </Menu.Item>
                          <Menu.Item
                            link
                            onClick={this.handleSpdx}
                          >
                            <Icon name="download" style={iconStyle} />
                            {t('card.menu.spdx')}
                          </Menu.Item>
                          <Menu.Item
                            link
                            onClick={this.handleCycloneDx}
                          >
                            <Icon name="download" style={iconStyle} />
                            CycloneDX
                          </Menu.Item>
                          <Menu.Item
                            link
                            onClick={this.handleVexBom}
                          >
                            <Icon name="download" style={iconStyle} />
                            VEX
                          </Menu.Item>
                          <Menu.Item
                            link
                            onClick={this.handleNIS}
                          >
                            <Icon name="download" style={iconStyle} />
                            NIS
                          </Menu.Item>
                        </Menu>
                      </Popup>
                      {this.renderBookMark()}
                      {currentPrecisionLevel === 'narrow' ? (
                        <Popup
                          trigger={(
                            <a className="icon_box">
                              <Icon
                                name="arrow alternate circle up"
                              />
                            </a>
                          )}
                          content={t('modal.content.precision_level_narrow')}
                          inverted
                          position="bottom left"
                          style={tooltipStyle}
                        />
                      ) : null}
                      {currentPrecisionLevel === 'medium' ? (
                        <Popup
                          trigger={(
                            <a className="icon_box">
                              <Icon
                                name="exchange"
                              />
                            </a>
                          )}
                          content={t('modal.content.precision_level_medium')}
                          inverted
                          position="bottom left"
                          style={tooltipStyle}
                        />
                      ) : null}
                      {currentPrecisionLevel === 'broad' ? (
                        <Popup
                          trigger={(
                            <a className="icon_box">
                              <Icon
                                name="arrow alternate circle down"
                              />
                            </a>
                          )}
                          content={t('modal.content.precision_level_broad')}
                          inverted
                          position="bottom left"
                          style={tooltipStyle}
                        />
                      ) : null}
                    </div>
                  </div>
                )
                  : (
                    <HeaderError
                      errorHeader={errorHeader}
                      errorBody={errorBody}
                      goBack={this.goBack}
                    />
                  )
              }
              <HeaderLinkDetail overviewSummary={overviewSummary} props={this.props} />
            </div>
          </div>
          <ExportModal
            isOpenMED={modalExportIsOpen}
            onClose={this.closeExportModal}
            handleModal={this.downloadReport}
            isDownloading={isDownloadingReport}
            birdView
            rowData={overviewSummary}
            translate={t}
          />
        </div>
        <div className="contents_summary">
          <div className="contents_summary_inner">
            <div className="contents_summary_box">
              <div className="overview">
                <table className="summary_item_table">
                  <colgroup>
                    <col style={{ width: '18px' }} />
                    <col style={{ width: '16px' }} />
                    <col style={{ width: '16px' }} />
                    <col style={{ width: '18px' }} />
                    <col style={{ width: '16px' }} />
                    <col style={{ width: '16px' }} />
                  </colgroup>
                  <tbody>
                    <tr>
                      <td>
                        <div className="summary_item">
                          <p className="label">{t('panel.menu.license')}</p>
                          <p className="value">{licenseCount && this.abbreviateNumber(licenseCount.total)}</p>
                        </div>
                        <Popup
                          trigger={(
                            <div className="summary_chart bubble_chart">
                              <div className="">
                                <div className="inner red">
                                  {licenseCount && this.abbreviateNumber(licenseCount.protective)}
                                </div>
                              </div>
                              <div>
                                <div className="inner cheese">
                                  {licenseCount && this.abbreviateNumber(licenseCount.permissive)}
                                </div>
                              </div>
                              <div>
                                <div className="inner yellow">
                                  {licenseCount && this.abbreviateNumber(licenseCount.others)}
                                </div>
                              </div>
                            </div>
                          )}
                          inverted
                        >
                          <List>
                            <List.Item>
                              <List.Icon
                                name="square"
                                style={{ color: '#ff440c', fontSize: '11px' }}
                              />
                              <span className="tip red">{t('panel.menu.red')}</span>
                              <span className="tip">
                                {' '}
                                =
                                {' '}
                                {t('panel.menu.protective')}
                              </span>
                            </List.Item>
                            <List.Item>
                              <List.Icon
                                name="square"
                                style={{ color: '#ffae00', fontSize: '11px' }}
                              />
                              <span className="tip orange">{t('panel.menu.orange')}</span>
                              <span className="tip">
                                {' '}
                                =
                                {' '}
                                {t('panel.menu.permissive')}
                              </span>
                            </List.Item>
                            <List.Item>
                              <List.Icon
                                name="square"
                                style={{ color: '#ffde00', fontSize: '11px' }}
                              />
                              <span className="tip yellow">{t('panel.menu.yellow')}</span>
                              <span className="tip">
                                {' '}
                                =
                                {' '}
                                {t('panel.menu.others')}
                              </span>
                            </List.Item>
                          </List>
                        </Popup>
                      </td>
                      <td>
                        <div className="summary_item big">
                          <p className="label">{t('panel.menu.license_issue_status')}</p>
                          {licenseStatus && this.renderBarChart(licenseStatus)}
                        </div>
                      </td>
                      <td>
                        <div className="list_wrap">
                          <p className="list_title">{t('panel.menu.most_found_license')}</p>
                          <ul>
                            {licenseMostFound && licenseMostFound.length !== 0
                              ? licenseMostFound.map((item) => {
                                return (
                                  <li
                                    key={uuidv4()}
                                    className={cx(
                                      'bullet round',
                                      {
                                        red: item.family === 'protective',
                                      },
                                      {
                                        orange: item.family === 'permissive',
                                      },
                                      {
                                        yellow: item.family === 'others',
                                      }
                                    )}
                                  >
                                    <span className="name">{item.name}</span>
                                    <span className="val">{item.uploaded_file_count}</span>
                                  </li>
                                );
                              })
                              : null}
                          </ul>
                        </div>
                      </td>
                      <td style={{ paddingLeft: '30px' }}>
                        <div className="summary_item">
                          <p className="label">{t('panel.menu.litigator')}</p>
                          <p className="value red">{litigatorCount && litigatorCount}</p>
                        </div>
                      </td>
                      <td>
                        <div className="summary_item big">
                          <p className="label">{t('panel.menu.litigator_issue_status')}</p>
                          {litigatorStatus && this.renderBarChart(litigatorStatus)}
                        </div>
                      </td>
                      <td>
                        <div className="list_wrap">
                          <p className="list_title">{t('panel.menu.most_found_litigator')}</p>
                          <ul>
                            {litigatorMostFound && litigatorMostFound.length !== 0
                              ? litigatorMostFound.map((lit) => {
                                return (
                                  <li key={uuidv4()}>
                                    <span
                                      className="name has_link"
                                      onClick={(e) => {
                                        return this.handleLitigatorDetailModal(e, lit.code);
                                      }}
                                      onKeyUp={(e) => {
                                        return this.handleLitigatorDetailModal(e, lit.code);
                                      }}
                                    >
                                      {lit.code}
                                    </span>
                                    <span className="val">{lit.uploaded_file_count}</span>
                                  </li>
                                );
                              })
                              : null}
                          </ul>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <LitigatorDetailModal
            isOpenMLD={isOpenMLD}
            closeModal={this.handleMLDClose}
            litigatorData={litigatorData}
          />
          <SPDXDocumentGenerator
            isOpenMCX={isOpenMCX}
            reportId={params.idReport}
            uploadedFileName={uploadName}
            closeModal={this.closeExportModal}
            translate={t}
          />
          <CycloneDXDocumentGenerator
            isOpenMCD={isOpenMCD}
            reportId={params.idReport}
            closeModal={this.closeExportModal}
            translate={t}
          />
          <VexGenerator
            isOpenMVX={isOpenMVX}
            reportId={params.idReport}
            closeModal={this.closeExportModal}
            translate={t}
          />
          <NISModal
            isOpenMNA={isOpenMNA}
            reportId={params.idReport}
            closeModal={this.closeExportModal}
            translate={t}
          />
          <CBOMGenerator
            isOpenMCB={isOpenMCB}
            reportId={params.idReport}
            fileName={uploadName}
            closeModal={this.closeModal}
            translate={t}
          />
          <Modal open={isOpenAlertModal} onClose={this.closeModal}>
            <div className="modal_popup_wrap confirm_wrap">
              <div className="modal_popup_box confirm_box">
                <div className="modal_popup confirm">
                  <h2 className="title">{this.modalAction}</h2>
                  {
                    toExport === 's3' ? (
                      <Modal.Description>
                        <Header>
                          {this.modalBody}
                        </Header>
                        {this.modalHeader}
                        {this.modalSubBody}
                      </Modal.Description>
                    ) : (
                      <Modal.Description>
                        <Header>
                          {this.modalBody}
                        </Header>
                        <p className="modal_list">{this.modalHeader}</p>
                        <p>{this.modalSubBody}</p>
                      </Modal.Description>
                    )
                  }

                  <div className="button_wrap">
                    <a className="center_button" onClick={this.closeModal} onKeyUp={this.closeModal}>
                      {t('modal.button.ok')}
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </Modal>
        </div>
      </div>
    );
  }
}

export default WithRouter(withTranslation()(inject('state')(observer(LicenseDetailedPanel))));
